import $ from 'jquery'
import Rails from '@rails/ujs'

$.fn.loading = function(toggle = true) {
  return this.each((i, el) => {
    if ($(el).is('.btn')) {
      $(el).toggleClass('active btn-loading', toggle)
    } else if (el.disabled == true || el.disabled == false) {
      el.disabled = toggle
    } else if ($(el).is('form, div')) {
      if (toggle) {
        $(el).wrapAll('<div class="dimmer"></div>').wrapAll('<div class="dimmer-content">').parents('.dimmer').append('<div class="loader">').addClass('active')
      } else {
        $(el).unwrap('.dimmer-content').unwrap('.dimmer').siblings('.loader').remove()
      }
    }
  })
};

$(document).on('click', 'a[href]:not([target], [data-remote], [href^="javascript:;"] , [href^="#"], [href^="tel:"], [href^="mailto:"], [data-trigger], [data-toggle], [data-target], .disabled, [disabled])', function(ev) {
  if (ev.ctrlKey || ev.shiftKey || ev.metaKey || (ev.button && ev.button == 1)) return;
  $(this).loading(true);
});

$(document).on('click', '[data-target="modal"]', function(ev) {
  ev.preventDefault();

  // trigger visual loading state
  $(this).loading();

  // makes @rails/ujs view this link as remote
  this.dataset.remote = true

  // remove visual loading state when AJAX request is complete
  $(this).one("ajax:complete", () => $(this).loading(false))

  Rails.handleRemote.call(this, ev)
});

$(document).on('ajax:success', '[data-target="modal"]', function(ev) {
  const [response, status, xhr] = ev.detail
  const data = new XMLSerializer().serializeToString(response)

  let modal = $($.parseHTML(data, document, true)[0]).appendTo(document.body)

  modal.one('ajax:success', (ev) => {
    if ($(ev.target).data('hide') == 'modal')
      modal.modal('hide');
  });

  modal.modal('show')
    .one('hidden.bs.modal', (ev) => {
      modal.remove();
    });
});

function triggerForm(ev) {
  ev.preventDefault();

  let form = $(this).parents('form');
  let selector = $(this).data('form');
  if (selector) form = $(selector);

  form.submit().one('ajax:complete', () => {
    $(this).loading(false);
  });

  $(this).loading(true);
}

$(document).on('change', '[data-trigger="form"]:input', triggerForm);

$(document).on('change', '[data-reload="form"]', function() {
  $[$(this.form).data('reload-method') || 'get']($(this.form).loading(true).data('url'), $(this.form).serialize(), (data) => {
    const replacement = $($.parseHTML(data, document, true))
    $(this.form).replaceWith(replacement)
    replacement.loading(false);
  });
});

$(document).on('ajax:before', function(ev) {
  $(this).loading(true);
});

$(document).on('ajax:complete', function(ev) {
  const [xhr, status] = ev.detail
  $(this).loading(false);
  if (xhr.responseText) {
    let html = $.parseHTML(xhr.responseText, document, true);
    $.each(html, (i, el) => {
      if (el.id) $(`[id="${el.id}"]`).replaceWith(el);
    });
  } else {
    let location = xhr.getResponseHeader('Location');
    if (location) {
      $(document.body).loading(true);
      location == '.' ? window.location.reload(true) : (window.location = location);
    }
  }
});

$(document).on('ajax:error', function(ev) {
  const [response, status, xhr] = ev.detail

  if (xhr.status == 500)
    showError('I\'m sorry, we couldn\'t process your request. Please contact support using the chat icon in the bottom right of your screen!');
  else if (xhr.status == 404)
    showError('I\'m sorry but we couldn\'t find what you were looking for, maybe it is no longer there. Try refreshing the page.');
  else if (xhr.status == 400)
    showError('I\'m sorry but we couldn\'t complete your request.');
});
